import { ApiEpWatermark } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "watermark.config";

export const useQueryWatermarkConfig = (
  options?: Omit<
    UseQueryOptions<Await<ReturnType<typeof ApiEpWatermark.config>>>,
    "queryKey" | "queryFn"
  >,
) =>
  useQuery<Await<ReturnType<typeof ApiEpWatermark.config>>>(
    [KEY],
    () => ApiEpWatermark.config(),
    options,
  );

useQueryWatermarkConfig.KEY = KEY;
